/**
 * @description Produces a deep clone (no references to original object or child objects) of the provided object or array.
 */
export function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.valueOf()) as T;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepClone(item)) as T;
  }

  const source = obj as Record<string, unknown>;
  const ret: Record<string, unknown> = {};
  for (const key of Object.keys(source)) {
    ret[key] = deepClone(source[key]);
  }

  return ret as T;
}
